<template>
  <v-card>
    <v-card-title class="cardtitle mb-2 rounded-0"
      >Antipoison Dog Unit</v-card-title
    >
    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-select
          v-model="newData.antipoisonDogUsed"
          label="Antipoison dog used"
          :items="StdChoices"
          required
          :rules="required"
        />
        <v-select
          v-model="newData.antipoisonDogId"
          label="Antipoison dog ID"
          :items="antipoisondogid"
          :disabled="!(newData.antipoisonDogUsed === 'Yes')"
          multiple
          chips
          small-chips
          deletable-chips
          clearable
        />
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="error" @click="cancel">Cancel</v-btn>
      <v-btn color="grey lighten-2" @click="reset">Clear</v-btn>
      <v-btn :disabled="!valid || !isDirty" color="#7eb09f" @click="validate"
        >Save
        <v-progress-circular color="biscuit" v-if="loading" indeterminate />
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { sync, get } from "vuex-pathify";
import AntipoisonDogUnit from "@/models/antipoisondogunit.js";
import { StdChoices, AntipoisonDogID } from "@/utils/selectoptions.js";
export default {
  props: {
    AntipoisonDogUnit: {
      type: Object,
      default: function () {
        return {};
      },
    },
    passed: {
      type: Boolean,
      default: false,
    },
    entrycode: {
      type: Number,
    },
  },
  data: function () {
    return {
      valid: false,
      loading: false,
      required: [(v) => !!v || "Field is required"],
      StdChoices: StdChoices,
      AntipoisonDogID: AntipoisonDogID,
    };
  },
  methods: {
    validate() {
      this.loading = true;
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch("incidentsnew/updAntipoisondog", {
            entrycode: this.entrycode,
            payload: this.newData,
          })
          .then(() => {
            this.loading = false;
            this.initData = { ...this.newData };
          })
          .catch((e) => {
            console.log("error");
            // console.log(this.$store.state.incidentsnew.error)
          }); // FIXME
      } else {
        this.loading = false;
      }
    },
    cancel() {
      this.$router.back();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    // antipoisondogid () {
    //   return AntipoisonDogID
    // }
  },
  created() {
    this.newData = new AntipoisonDogUnit();
  },
  mounted() {
    if (this.passed) {
      this.initData = { ...this.AntipoisonDogUnit };
      this.newData = this.AntipoisonDogUnit;
      // The select is now "multiple", so v-model needs an array. Normalise
      // any older record that stored a single string ID so it still shows
      // up as selected instead of being dropped.
      if (
        this.newData.antipoisonDogId &&
        !Array.isArray(this.newData.antipoisonDogId)
      ) {
        this.newData.antipoisonDogId = [this.newData.antipoisonDogId];
      }
      if (
        this.initData.antipoisonDogId &&
        !Array.isArray(this.initData.antipoisonDogId)
      ) {
        this.initData.antipoisonDogId = [this.initData.antipoisonDogId];
      }
      this.$refs.form.resetValidation();
    }
  },
  computed: {
    ...sync("form", ["initData", "newData"]),
    ...get("form", ["isDirty"]),
    antipoisondogid() {
      if (this.passed) {
        if (this.initData.antipoisonDogId == null) {
          return AntipoisonDogID;
        }
        // initData.antipoisonDogId may be a single legacy string or an array
        // of selected IDs now that the field supports multiple selections.
        const selected = Array.isArray(this.initData.antipoisonDogId)
          ? this.initData.antipoisonDogId
          : [this.initData.antipoisonDogId];
        const missing = selected.filter((id) => !AntipoisonDogID.includes(id));
        return missing.length
          ? [...AntipoisonDogID, ...missing]
          : AntipoisonDogID;
      }
      // if (this.passed && !AntipoisonDogID.some(opt => opt === this.initData.antipoisonDogId)) {
      //   let seloptions = AntipoisonDogID
      //   console.log(seloptions)
      //   console.log(this.initData.antipoisonDogId)
      //   seloptions.push(this.initData.antipoisonDogId)
      //   return seloptions
      // }
      // return AntipoisonDogID;
    },
  },
};
</script>
<style scoped>
.cardtitle {
  background-color: #7eb09f;
}
</style>